import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { GurdServiceService } from 'src/app/Service/gurd-service.service';
import { ActivatedRoute, Router } from '@angular/router';
import { OtherService } from 'src/app/Service/other.service';
import { Location } from '@angular/common';
import { NotificationService } from 'src/app/Service/notification.service';
import { DataService } from 'src/app/Service/data.service';
import axios from 'src/app/Service/axios';
import momentJalaali from 'moment-jalaali';
declare let $: any;

@Component({
  selector: 'entryCar',
  templateUrl: './entryCar.component.html',
  styleUrls: ['./entryCar.component.css'],
})
export class EntryCarComponent implements OnInit {
  permissions: any;
  modeId: any = 1;
  carId: number = 0;
  car: any;
  isEditMode = false;
  isDeviceIdLocked = false;
  isLoading = true;
  checkingDeviceId = false;
  formSubmitted = false;

  carNameList: any[] = [];
  carIconList: any[] = [];
  vehicleKinds: any;
  gpsTypeList: any[] = [];

  selectedCarIcon: any = null;
  gpsTypeLocked = false;

  mobileUsages: any[] = [];
  plateTypes: any[] = [];
  carGroups: any[] = [];
  appUsages: any[] = [];
  mobileDomains: any[] = [];
  officialStatuses: any[] = [];

  inputTitles: any;
  inputUsages: any;
  inputAssignments: any;
  inputValueTitles: any;

  plainForm: FormGroup = this.formBuilder.group({
    tiMobileIcon: new FormControl('-1', this.otherService.zeroOrMoreValidator()),
    tiGPSType: new FormControl(null, this.otherService.zeroOrMoreValidator()),
    tiMobileType: new FormControl('-1', this.otherService.zeroOrMoreValidator()),
    tiMobileGroup: new FormControl('-1', this.otherService.zeroOrMoreValidator()),
    strFullName: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strMobile: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strColor: new FormControl(''),
    strVIN: new FormControl(''),
    iYearConstruction: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strComment: new FormControl(''),
    strVehicleNo: new FormControl(),
    strValidDate: momentJalaali().format('jYYYY/jMM/01'),
    strDefinationDate: momentJalaali().format('jYYYY/jMM/01'),
    bActive: new FormControl(true),
    bFlowmeter: new FormControl(false),
    bOfficial: new FormControl(false),
    pic: new FormControl(),
    Plak4: new FormControl('', this.otherService.zeroOrMoreValidator()),
    Plak3: new FormControl('', this.otherService.zeroOrMoreValidator()),
    Plak2: new FormControl('الف'),
    Plak1: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strUnitId: new FormControl(),
    bSeepad: new FormControl(),
    strPassword: new FormControl('', this.otherService.zeroOrMoreValidator()),
    fLastKM: new FormControl(),
    strVehicleType: new FormControl(''),
    iCode: new FormControl(''),
    tiPassenger: new FormControl('1'),
    tiFuelType: new FormControl('1', this.otherService.zeroOrMoreValidator()),
    tiMobileUsage: new FormControl('-1'),
    tiPlateType: new FormControl('-1'),
    fFuelTankCapacity: new FormControl('0'),
  });

  inputForm: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.sysUser),
    strSession: new FormControl(this.sessionToken),
    strUnitID: new FormControl(),
    strIOTitle: new FormControl('-1'),
    iIOUsage: new FormControl('-1'),
  });

  greenPaperForm: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.sysUser),
    strSession: new FormControl(this.sessionToken),
    tiCylinders: new FormControl('4'),
    tiAxis: new FormControl('2'),
    tiWheels: new FormControl('4'),
    strUnitID: new FormControl(''),
    strEngineNumber: new FormControl(''),
    strChassisNumber: new FormControl(''),
    iCylinderVolume: new FormControl('0'),
    strOwnerFullName: new FormControl(''),
    strOwnerFatherName: new FormControl(''),
    strOwnerBirthDate: new FormControl(''),
    strOwnerCertificateNumber: new FormControl(''),
    strOwnerNationalCode: new FormControl(''),
    strOwnerPlaceIssue: new FormControl(''),
    strOwnerPostalCode: new FormControl(''),
    strOwnerAdress: new FormControl(''),
  });

  gpsForm: FormGroup = this.formBuilder.group({
    strStartTime: new FormControl('00:00'),
    strEndTime: new FormControl('23:59'),
    bSeepad: new FormControl(),
    bOfficial: new FormControl(),
    tiMobileIcon: new FormControl('', this.otherService.zeroOrMoreValidator()),
    tiGPSType: new FormControl(null, this.otherService.zeroOrMoreValidator()),
    tiMobileType: new FormControl('-1', this.otherService.zeroOrMoreValidator()),
    tiMobileGroup: new FormControl('-1', this.otherService.zeroOrMoreValidator()),
    strFullName: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strColor: new FormControl(''),
    strVIN: new FormControl(''),
    strValidDate: momentJalaali().format('jYYYY/jMM/01'),
    strPersonnelID: new FormControl(''),
    strDefinationDate: momentJalaali().format('jYYYY/jMM/01'),
    bActive: new FormControl(true),
    bFlowmeter: new FormControl(false),
    iYearConstruction: new FormControl(0),
    strComment: new FormControl(''),
    strVehicleNo: new FormControl(),
    bIncomplete: new FormControl(),
    pic: new FormControl(),
    fLastKM: new FormControl(''),
    strMobile: new FormControl('', this.otherService.zeroOrMoreValidator()),
    tiMaxSpeed: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strCellNo: new FormControl(''),
    strPassword: new FormControl('', this.otherService.zeroOrMoreValidator()),
    iGPS: new FormControl(null, this.otherService.zeroOrMoreValidator()),
    fGasPer100_HW: new FormControl(''),
    fMinVoltage: new FormControl('0'),
    strProvinceCode: new FormControl(''),
    fGasPer100_Tr: new FormControl(''),
    fGasPer100: new FormControl(''),
    Plak4: new FormControl('', this.otherService.zeroOrMoreValidator()),
    Plak3: new FormControl('', this.otherService.zeroOrMoreValidator()),
    Plak2: new FormControl('الف'),
    Plak1: new FormControl('', this.otherService.zeroOrMoreValidator()),
    strUnitId: new FormControl('', this.otherService.zeroOrMoreValidator()),
    bHasGPS: new FormControl(true),
    bTanker: new FormControl(false),
    bFuelSensor: new FormControl(false),
    bDashCam: new FormControl(false),
    bWeightSensor: new FormControl(false),
    bTemperatureSensor: new FormControl(false),
    bOBD2: new FormControl(false),
    strVehicleType: new FormControl(''),
    iCode: new FormControl(''),
    tiPassenger: new FormControl('1'),
    tiFuelType: new FormControl('1', this.otherService.zeroOrMoreValidator()),
    tiMobileUsage: new FormControl('-1', this.otherService.zeroOrMoreValidator()),
    tiPlateType: new FormControl('-1'),
    fFuelTankCapacity: new FormControl('0'),
  });

  tariffForm: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.sysUser),
    strSession: new FormControl(this.sessionToken),
    strUnitID: new FormControl(0),
    iHourlyRate: new FormControl(0),
    iOvertimeRate: new FormControl(0),
    iUrbanOperationRates: new FormControl(0),
    iNonurbanOperatingRates: new FormControl(0),
    iOvernightStopRate: new FormControl(0),
    iIncentiveOvertime: new FormControl(0),
    iIncentiveKm: new FormControl(0),
    strStartTime: new FormControl('7:00'),
    strEndTime: new FormControl('16:00'),
  });

  extraInfoForm: FormGroup = this.formBuilder.group({
    iSystemUser: new FormControl(this.sysUser),
    strSession: new FormControl(this.sessionToken),
    strUnitID: new FormControl(''),
    strPersonnelID: new FormControl(''),
    tiAppUsages: new FormControl('-1'),
    tiOfficialStatus: new FormControl('-1'),
    iMobileDomain: new FormControl('-1'),
    iCode: new FormControl('-1'),
    strBankAccount: new FormControl(''),
    bEnableTimer: new FormControl(false),
    iPeriodSendingLoc: new FormControl(-1),
    iLocationCourseSending: new FormControl(-1),
    strStartTime: new FormControl(''),
    strEndTime: new FormControl(''),
    strManagerMobile: new FormControl(''),
    bCheckPosition4Ready: new FormControl(false),
    bHastrafficLoc: new FormControl(false),
    bHasEvenoddb: new FormControl(false),
  });

  constructor(
    private formBuilder: FormBuilder,
    private _location: Location,
    private router: Router,
    private otherService: OtherService,
    private route: ActivatedRoute,
    private notifyService: NotificationService,
    private dataService: DataService,
    private gurdService: GurdServiceService,
  ) {}

  private get sysUser(): string {
    return this.gurdService.decrypt(window.localStorage.getItem('ID')!);
  }

  private get sessionToken(): string {
    return this.gurdService.decrypt(window.localStorage.getItem('Session')!);
  }

  private authQuery(): string {
    return `iSystemUser=${this.sysUser}&strSession=${encodeURIComponent(this.sessionToken)}`;
  }

  private authBody(extra: Record<string, any> = {}): any {
    return { iSystemUser: this.sysUser, strSession: this.sessionToken, ...extra };
  }

  private parseData(data: any): any {
    return typeof data === 'string' ? JSON.parse(data) : data;
  }

  private async apiPost(api: string, body: any = {}): Promise<any> {
    return this.parseData((await axios.post(api, body)).data);
  }

  private async withSpinner<T>(task: () => Promise<T>): Promise<T> {
    this.otherService.Showspinner();
    try {
      return await task();
    } finally {
      this.otherService.nonespinner();
    }
  }

  private gotoLogin(errorCode?: string): void {
    this.otherService.removeLocalStorage();
    if (errorCode) this.router.navigate(['login'], { queryParams: { error: errorCode } });
    else this.router.navigate(['login']);
  }

  private sessionExpired(data: any, message: string | null, errorCode?: string): boolean {
    if (data?.ISSessionExpired == true) {
      if (message) this.notifyService.showError(message);
      this.gotoLogin(errorCode);
      return true;
    }
    return false;
  }

  private confirmAction(opts: {
    title: string;
    type: string;
    okText: string;
    okClass: string;
    onOk: () => void;
  }): void {
    $.confirm({
      title: opts.title,
      content: '',
      type: opts.type,
      buttons: {
        ok: { text: opts.okText, btnClass: opts.okClass, keys: ['enter'], action: opts.onOk },
        cancel: { text: 'لغو' },
      },
    });
  }

  private splitPlateNo(vehicleNo: string): string[] {
    return `${vehicleNo || ''} `.split(' ');
  }

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.modeId = params['id'];
      if (params['Imei']) {
        this.carId = params['Imei'];
        this.tariffForm.patchValue({ strUnitID: this.carId });
        this.inputForm.patchValue({ strUnitID: this.carId });
        this.greenPaperForm.patchValue({ strUnitID: this.carId });
        this.isEditMode = true;
      }
      this.loadBaseData();
    });

    setTimeout(() => {
      $('.clockpicker').clockpicker({ donetext: 'top', align: 'top', autoclose: true });
    }, 500);

    $('#workly-gps-modal').on('hidden.bs.modal', () => {
      this.inputForm.patchValue({ strIOTitle: '-1', iIOUsage: '-1' });
    });

    this.permissions = JSON.parse(
      this.gurdService.decrypt(window.localStorage.getItem('menu') as any),
    );

    if (this.modeId == 1 || this.modeId == 3) {
      if (this.modeId == 3) this.gpsForm.get('bOfficial')?.setValue(true);
      this.gpsForm.disable();
      this.gpsForm.get('strUnitId')?.enable();
      if (this.carId != 0 && this.carId != null) {
        this.loadCar(this.carId);
        this.gpsForm.enable();
        this.isDeviceIdLocked = true;
        this.isLoading = false;
        this.loadTariff();
        this.loadInputs();
      }
    } else this.loadCar(this.carId);
  }

  loadBaseData = async () => {
    if (!this.isEditMode) {
      this.carIconList = await this.apiPost(`GetMobileIcon`);
      this.carNameList = await this.apiPost(`GetGPSType`);
    }
    this.vehicleKinds = await this.apiPost(`GetMobileType`);
    this.gpsTypeList = await this.apiPost(`GetGPS`);
    this.mobileUsages = await this.apiPost(`MobileUsage_List`);
    this.plateTypes = await this.apiPost(`PlateType_List`);
    this.carGroups = await this.apiPost(`GetMobileGroup`);
  };

  deleteInputUsage(ioId: any) {
    this.confirmAction({
      title: `آیا از حذف این کاربری اطمینان دارید ؟`,
      type: 'red',
      okText: 'حذف',
      okClass: 'btn-success',
      onOk: async () => {
        const res = await this.apiPost(
          `IO_DeleteIOMobileUsage`,
          this.authBody({ iIOMobileUsage: ioId }),
        );
        if (res.iResult == 0) return this.notifyService.showError(res.strError);
        if (this.sessionExpired(res, 'لطفا وارد سیستم شوید', '91')) return;
        this.notifyService.showSuccess('با موفقیت حذف شد');
        this.inputAssignments = this.inputAssignments.filter(
          (el: any) => el.iIOMobileUsage != ioId,
        );
      },
    });
  }

  loadValueTitles = async (ioId: any) => {
    const res = await this.apiPost(
      `IO_GetIOValueTitle`,
      this.authBody({ iIOMobileUsage: ioId }),
    );
    if (res.iResult == 0) return this.notifyService.showError(res.strError);
    if (this.sessionExpired(res, 'لطفا وارد سیستم شوید', '92')) return;
    this.inputValueTitles = res;
  };

  goBack() {
    this._location.back();
  }

  addInputUsage = async () => {
    const model = this.inputForm.value;
    if (model.iIOUsage == -1)
      return this.notifyService.showError('لطفا کاربری را وارد کنید');
    if (model.strIOTitle == -1)
      return this.notifyService.showError('لطفا ورودی را وارد کنید');
    const res = await this.apiPost(`IO_AddIOMobileUsage`, model);
    if (res.iResult == 0) return this.notifyService.showError(res.strError);
    if (this.sessionExpired(res, 'لطفا وارد سیستم شوید', '93')) return;
    this.notifyService.showSuccess('با موفقیت ثبت شد');
    this.inputAssignments.push(res);
    this.inputForm.patchValue({ strIOTitle: '-1', iIOUsage: '-1' });
  };

  loadInputs = async () => {
    const [titles, usages, assigned] = await Promise.all([
      this.apiPost(`IO_GetIOTitle`),
      this.apiPost(`IO_GetIOUsage`),
      this.apiPost(`IO_GetIOMobileUsage`, this.authBody({ strUnitID: this.carId })),
    ]);
    this.inputTitles = titles;
    this.inputUsages = usages;
    this.inputAssignments = assigned;
  };

  loadCar = async (id: any) => {
    if (!id) return;

    const resp = await this.withSpinner(() =>
      axios.post(`GetMobile?${this.authQuery()}&strIMEI=${id}`),
    );
    if (this.sessionExpired(resp.data, 'نشست کاربری شما منقضی شده است!', '94')) return;
    if (resp.data.iResult != 1)
      return this.notifyService.showError('مشکلی پیش آمده است');

    this.car = resp.data;

    const [gpsTypes, names, icons] = await this.withSpinner(() =>
      Promise.all([
        this.apiPost(`GetGPS`),
        this.apiPost(`GetGPSType`),
        this.apiPost(`GetMobileIcon`),
      ]),
    );
    this.gpsTypeList = gpsTypes;
    this.carNameList = names;
    this.carIconList = icons;

    const plate = this.splitPlateNo(this.car.strVehicleNo);
    const icon = icons.find(
      (el: any) => el.tiMobileIcon == `${this.car.tiMobileIcon}`,
    );
    this.selectedCarIcon = icon || null;
    const iconName = icon?.strComment;

    if (this.modeId == 1) {
      this.gpsForm.reset({
        strUnitId: this.car.strUnitId,
        strValidDate: this.car.strValidDate,
        strPersonnelID: this.car.strPersonnelID,
        strDefinationDate: this.car.strDefinationDate,
        bActive: this.car.bActive,
        bFlowmeter: this.car.bFlowmeter,
        tiMobileIcon: this.car.tiMobileIcon,
        tiGPSType: this.car.tiGPSType,
        tiMobileType: this.car.tiMobileType,
        tiMobileGroup: this.car.tiMobileGroup,
        strFullName: this.car.strFullName,
        strColor: this.car.strColor,
        strVIN: this.car.strVIN,
        iYearConstruction: this.car.iYearConstruction,
        strComment: this.car.strComment,
        fLastKM: Math.round(this.car.fLastKM),
        strMobile: this.car.strMobile,
        tiMaxSpeed: this.car.tiMaxSpeed,
        strCellNo: this.car.strCellNo,
        strPassword: this.car.strPassword,
        iGPS: this.car.iGPS,
        fGasPer100_HW: this.car.fGasPer100_HW,
        fMinVoltage: this.car.fMinVoltage,
        strProvinceCode: this.car.strProvinceCode,
        fGasPer100_Tr: this.car.fGasPer100_Tr,
        fGasPer100: this.car.fGasPer100,
        Plak1: plate[0],
        Plak2: plate[1],
        Plak3: plate[2],
        Plak4: plate[4],
        pic: iconName,
        bIncomplete: this.car.bIncomplete,
        strStartTime: this.car.strStartTime,
        strEndTime: this.car.strEndTime,
        bSeepad: this.car.bSeepad,
        bOfficial: this.car.bOfficial,
        strVehicleType: this.car.strVehicleType,
        iCode: this.car.iCode,
        tiPassenger: this.car.tiPassenger,
        tiFuelType: this.car.tiFuelType,
        tiMobileUsage: this.car.tiMobileUsage,
        tiPlateType: this.car.tiPlateType,
        bTanker: this.car.bTanker,
        bFuelSensor: this.car.bFuelSensor,
        bDashCam: this.car.bDashCam,
        bWeightSensor: this.car.bWeightSensor,
        bTemperatureSensor: this.car.bTemperatureSensor,
        bOBD2: this.car.bOBD2,
        fFuelTankCapacity: this.car.fFuelTankCapacity,
      });

      if (!this.permissions.bEditExpiredDate)
        ['fGasPer100_HW', 'fGasPer100_Tr', 'fGasPer100'].forEach((key) =>
          this.gpsForm.get(key)?.disable(),
        );
    } else {
      this.plainForm.reset({
        strUnitId: this.car.strUnitId,
        strDefinationDate: this.car.strDefinationDate,
        bActive: this.car.bActive,
        bFlowmeter: this.car.bFlowmeter,
        bOfficial: this.car.bOfficial,
        strValidDate: this.car.strValidDate,
        tiMobileIcon: this.car.tiMobileIcon,
        tiGPSType: this.car.tiGPSType,
        tiMobileType: this.car.tiMobileType,
        tiMobileGroup: this.car.tiMobileGroup,
        strFullName: this.car.strFullName,
        strColor: this.car.strColor,
        strVIN: this.car.strVIN,
        iYearConstruction: this.car.iYearConstruction,
        strComment: this.car.strComment,
        strMobile: this.car.strMobile,
        bSeepad: this.car.bSeepad,
        fLastKM: this.car.fLastKM,
        Plak1: plate[0],
        Plak2: plate[1],
        Plak3: plate[2],
        Plak4: plate[4],
        pic: iconName,
        strVehicleType: this.car.strVehicleType,
        iCode: this.car.iCode,
        tiPassenger: this.car.tiPassenger,
        tiFuelType: this.car.tiFuelType,
        tiMobileUsage: this.car.tiMobileUsage,
        tiPlateType: this.car.tiPlateType,
        fFuelTankCapacity: this.car.fFuelTankCapacity,
      });
    }
  };

  private isEmpty(v: any): boolean {
    return v == null || v === '' || v == -1;
  }

  private isPlateInvalid(m: any): boolean {
    return (
      this.isEmpty(m.Plak1) ||
      this.isEmpty(m.Plak2) ||
      this.isEmpty(m.Plak3) ||
      this.isEmpty(m.Plak4)
    );
  }

  private isPlainModelValid(m: any): boolean {
    return (
      !this.isEmpty(m.strFullName) &&
      !this.isEmpty(m.tiMobileType) &&
      !this.isEmpty(m.tiMobileGroup) &&
      !this.isEmpty(m.tiGPSType) &&
      !this.isEmpty(m.iYearConstruction) &&
      !this.isEmpty(m.strMobile) &&
      m.strMobile.length == 11 &&
      (this.isEditMode || !this.isEmpty(m.strPassword)) &&
      !this.isPlateInvalid(m)
    );
  }

  private isGpsModelValid(m: any): boolean {
    const tracked = this.gpsForm.get('iGPS')?.value != 0;
    return (
      !this.isEmpty(m.strUnitId) &&
      !this.isEmpty(m.tiMobileType) &&
      !this.isEmpty(m.tiMobileGroup) &&
      !this.isEmpty(m.tiGPSType) &&
      !this.isEmpty(m.tiMobileIcon) &&
      !this.isEmpty(m.strFullName) &&
      !this.isEmpty(m.strMobile) &&
      !this.isEmpty(m.tiMaxSpeed) &&
      (!tracked || !this.isEmpty(m.strCellNo)) &&
      (!tracked || !this.isEmpty(m.iGPS)) &&
      !this.isEmpty(m.strPassword) &&
      !this.isEmpty(m.strStartTime) &&
      !this.isEmpty(m.strEndTime) &&
      !this.isPlateInvalid(m)
    );
  }

  submitPlainForm = async () => {
    this.formSubmitted = true;
    this.plainForm.markAllAsTouched();

    var model = this.plainForm.value;

    if (!this.isPlainModelValid(model))
      return this.notifyService.showError('موارد ضروری را وارد کنید');

    if (this.isEmpty(model.tiMobileIcon)) model.tiMobileIcon = '-1';

    model.strVehicleNo = `${model.Plak1} ${model.Plak2} ${model.Plak3} | ${model.Plak4}`;

    this.confirmAction({
      title: `آیا از ${this.isEditMode ? ' ویرایش ' : ' ثبت '} اطلاعات اطمینان دارید ؟`,
      type: this.isEditMode ? 'blue' : 'green',
      okText: this.isEditMode ? 'ویرایش' : 'ثبت',
      okClass: this.isEditMode ? 'btn-primary' : 'btn-success',
      onOk: async () => {
        const resp = await axios.post(
          `AddOrEditMobileWithoutGPS?${this.authQuery()}`,
          this.otherService.stringNumberToNumber(model),
        );
        if (this.sessionExpired(resp.data, null, '95')) return;
        if (resp.data == -100) {
          this.notifyService.showError('لطفا وارد سیستم شوید');
          return this.gotoLogin();
        }
        if (resp.data.iResult == 0 && resp.data.strError)
          return this.notifyService.showError(resp.data.strError);
        this.notifyService.showSuccess('عملیات با موفقیت انجام شد');
        this.router.navigateByUrl(`/carInfo/${resp.data.strUnitId}`);
      },
    });
  };

  submitGpsForm = async () => {
    this.formSubmitted = true;
    this.gpsForm.markAllAsTouched();

    var model = this.gpsForm.value;

    if (!this.isGpsModelValid(model))
      return this.notifyService.showError('موارد ضروری را وارد کنید');

    if (!this.permissions.bEditExpiredDate && this.isEditMode) {
      model.fGasPer100_HW = this.car?.fGasPer100_HW || 0;
      model.fGasPer100_Tr = this.car?.fGasPer100_Tr || 0;
      model.fGasPer100 = this.car?.fGasPer100 || 0;
    }

    model.strVehicleNo = `${model.Plak1} ${model.Plak2} ${model.Plak3} | ${model.Plak4}`;
    model.strStartTime = (document.getElementById('startTime') as HTMLInputElement).value;
    model.strEndTime = (document.getElementById('endTime') as HTMLInputElement).value;

    const resp = await this.withSpinner(() =>
      axios.post(
        `AddOrEditMobile?${this.authQuery()}`,
        this.otherService.stringNumberToNumber(model),
      ),
    );
    if (this.sessionExpired(resp.data, 'نشست کاربری شما منقضی شده است!', '96')) return;
    if (resp.data == -100) {
      this.notifyService.showError('لطفا وارد سیستم شوید');
      return this.gotoLogin();
    }
    if (resp.data.iResult == 0 && resp.data.strError)
      return this.notifyService.showError(resp.data.strError);
    if (resp.data.iResult == 1) {
      this.notifyService.showSuccess('با موفقیت ثبت شد');
      this.dataService.getData();
      this._location.back();
    }
  };

  verifyDeviceId = async () => {
    const deviceId = (document.getElementById('deviceId') as HTMLInputElement)?.value;
    if (!deviceId) return this.notifyService.showError('لطفا شناسه را وارد  کنید');

    this.checkingDeviceId = true;
    try {
      const resp = await axios.post(`GetMobile?${this.authQuery()}&strIMEI=${deviceId}`);
      if (this.sessionExpired(resp.data, 'لطفا وارد سیستم شوید', '97')) return;

      if (resp.data.iResult == -2)
        this.notifyService.showError('این شناسه قبلا استفاده شده است');
      if (resp.data.iResult == 1) this.loadCar(deviceId);
      if (resp.data.iResult == -1) {
        this.isLoading = false;
        this.gpsForm.enable();
        this.isDeviceIdLocked = true;
        this.gpsForm.get('tiMaxSpeed')?.setValue('120');
        this.notifyService.showSuccess('ثبت خودرو بلا مانع است');
      }
    } finally {
      this.checkingDeviceId = false;
    }
  };

  isDigitKey = (e: any): boolean => !isNaN(e.key);

  deleteCar = async () => {
    const model = this.modeId == 1 ? this.gpsForm.value : this.plainForm.value;
    if (!confirm('آیا از حذف این خودرو اطمینان دارید')) return;
    const resp = await axios.post(`DeleteMobile?${this.authQuery()}`, model);
    if (this.sessionExpired(resp.data, 'لطفا وارد سیستم شوید', '98')) return;
    if (resp.data.iResult == 0)
      return this.notifyService.showError(resp.data.strError);
    if (resp.data.iResult == 1) {
      this.notifyService.showSuccess('با موفقیت حذف شد');
      this.router.navigate(['/']);
    }
  };

  showGuide = () => this.otherService.guid(this.modeId == 1 ? 11 : 10);

  saveTariff = async () => {
    const model = this.tariffForm.value;
    model.strStartTime = (document.getElementById('Stime') as HTMLInputElement).value;
    model.strEndTime = (document.getElementById('Etime') as HTMLInputElement).value;
    const res = await this.apiPost(`Mobile_EditPriceList`, model);
    if (res.iResult == 0) return this.notifyService.showError(res.strError);
    if (this.sessionExpired(res, 'لطفا وارد سیستم شوید', '99')) return;
    this.notifyService.showSuccess('با موفقیت ثبت شد');
    this.loadTariff();
    $('#tariff').modal('hide');
  };

  loadTariff = async () => {
    const tariff = await this.apiPost(
      `Mobile_GetPriceList`,
      this.authBody({ strUnitID: this.carId }),
    );
    this.tariffForm.patchValue(tariff);
  };

  saveValueTitle = async (model: any) => {
    model.strValueTitle = (
      document.getElementById(`value${model.strValue}`) as HTMLInputElement
    ).value;
    const res = await this.apiPost(`IO_EditIOValueTitle`, {
      ...model,
      ...this.authBody(),
    });
    if (res.iResult == 0) return this.notifyService.showError(res.strError);
    if (this.sessionExpired(res, 'لطفا وارد سیستم شوید', '100')) return;
    this.notifyService.showSuccess('با موفقیت ثبت شد');
  };

  logout = () => {
    this.otherService.removeLocalStorage();
    this.router.navigate(['login']);
  };

  onCarIconChange(item: any) {
    const icon = item ? item.tiMobileIcon : '';
    const pic = item ? item.tiGPSType : '';
    this.plainForm.patchValue({ tiMobileIcon: icon, pic });
    this.gpsForm.patchValue({ tiMobileIcon: icon, pic });
  }

  generateUnitId = async (withoutTracker?: boolean) => {
    const imeiEl = document.getElementById('deviceId') as HTMLInputElement;
    if (withoutTracker) {
      // بدون ردیاب
      const newId = (
        await this.withSpinner(() => axios.post(`Mobile_GenerateUnitID`))
      ).data;
      imeiEl.value = newId;
      if (!this.gpsTypeList.some((el: any) => el.iGPS == 0))
        this.gpsTypeList = [...this.gpsTypeList, { iGPS: 0, strComment: 'بدون ردیاب' }];
      this.gpsTypeLocked = true;
      this.gpsForm.patchValue({ iGPS: 0, bHasGPS: false, strUnitId: newId });
      setTimeout(() => this.verifyDeviceId(), 100);
    } else {
      // تحت ردیاب
      imeiEl.value = '';
      this.gpsForm.disable();
      this.isDeviceIdLocked = false;
      this.gpsForm.get('strUnitId')?.enable();
      this.gpsForm.patchValue({ bHasGPS: true, iGPS: null });
      this.gpsTypeLocked = false;
    }
  };

  openExtraInfo = async () => {
    const model = this.otherService.stringNumberToNumber({
      ...this.car,
      strUnitID: this.car.strUnitId,
      ...this.authBody(),
    });

    const res = await this.withSpinner(() =>
      this.apiPost(`Mobile_GetAdditional`, model),
    );
    if (!this.appUsages.length) this.loadAppUsages();
    if (!this.mobileDomains.length) this.loadMobileDomains();

    if (res.bError) return this.notifyService.showError(res.strError);

    Object.keys(res[0]).forEach((key) => {
      this.extraInfoForm.get(key)?.setValue(res[0][key]);
    });

    this.extraInfoForm.get('strUnitID')?.setValue(this.carId);

    $('#additionalInfoModal').modal('show');
  };

  saveExtraInfo() {
    this.confirmAction({
      title: `آیا از ویرایش اطلاعات اطمینان دارید ؟`,
      type: 'blue',
      okText: 'ویرایش',
      okClass: 'btn-primary',
      onOk: async () => {
        this.extraInfoForm.patchValue({
          strStartTime: (document.getElementById('aStartTime') as HTMLInputElement).value,
          strEndTime: (document.getElementById('aEndTime') as HTMLInputElement).value,
        });
        const res = await this.withSpinner(() =>
          this.apiPost(
            `Mobile_EditAdditional`,
            this.otherService.stringNumberToNumber(this.extraInfoForm.value),
          ),
        );
        if (res.bError) return this.notifyService.showError(res.strError);
        this.notifyService.showSuccess('اطلاعات با موفقیت ویرایش شد');
        $('#additionalInfoModal').modal('hide');
      },
    });
  }

  loadAppUsages = async () => {
    const res = await this.apiPost(`AppUsage_List `, {});
    if (res.bError) return this.notifyService.showError(res.strError);
    this.appUsages = res;
  };

  loadMobileDomains = async () => {
    const res = await this.apiPost(
      `GetMobileDomain4Report?iSystemUser=${this.sysUser}`,
      {},
    );
    if (res.bError) return this.notifyService.showError(res.strError);
    this.mobileDomains = res;
  };

  openOfficialStatus = async () => {
    if (!this.officialStatuses.length) this.loadOfficialStatuses();
    if (this.car.tiOfficialStatus)
      this.extraInfoForm
        .get('tiOfficialStatus')
        ?.setValue(this.car.tiOfficialStatus);
    $('#officialStatus_Modal').modal('show');
  };

  loadOfficialStatuses = async () => {
    const res = await this.apiPost(`OfficialStatus_List`, {});
    if (res.bError) return this.notifyService.showError(res.strError);
    this.officialStatuses = res;
  };

  saveOfficialStatus = async () => {
    const res = await this.withSpinner(() =>
      this.apiPost(
        `Mobile_OfficialStatus_Edit`,
        this.otherService.stringNumberToNumber({
          ...this.authBody(),
          strUnitID: this.carId,
          tiOffitialStatus: this.extraInfoForm.get('tiOfficialStatus')?.value,
        }),
      ),
    );
    if (res.bError) return this.notifyService.showError(res.strError);
    this.notifyService.showSuccess('اطلاعات با موفقیت ویرایش شد');
    $('#officialStatus_Modal').modal('hide');
  };

  openGreenPaper = async () => {
    const res = await this.withSpinner(() =>
      this.apiPost(
        `Mobile_GreenPaper_Info`,
        this.otherService.stringNumberToNumber(this.greenPaperForm.value),
      ),
    );
    if (res.bError) return this.notifyService.showError(res.strError);
    if (res.length) {
      Object.keys(res[0]).forEach((key) => {
        this.greenPaperForm.get(key)?.setValue(res[0][key]);
      });
    }
    $('#greenPaper_Modal').modal('show');
  };

  saveGreenPaper = async () => {
    const res = await this.withSpinner(() =>
      this.apiPost(
        `Mobile_GreenPaper_Update`,
        this.otherService.stringNumberToNumber(this.greenPaperForm.value),
      ),
    );
    if (res.bError) return this.notifyService.showError(res.strError);
    this.notifyService.showSuccess('عملیات با موفقیت انجام شد');
    $('#greenPaper_Modal').modal('hide');
  };

  analyzeVoltage = async () => {
    const res = await this.withSpinner(() =>
      this.apiPost(
        `MobileHistory_GetPowerMinMaxBySpeed`,
        this.otherService.stringNumberToNumber(
          this.authBody({ strUnitID: this.carId }),
        ),
      ),
    );
    if (res == -1) return this.notifyService.showError('تحلیل ناموفق');
    if (res?.bError) return this.notifyService.showError(res.strError);
    this.gpsForm.patchValue({ fMinVoltage: res });
  };
  
}
